import { PremiumFeature } from 'gleblu-socket-api';
import { createAction } from 'redux-act';

import { Subscription } from '../../../models/interfaces/Subscriptions';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchSubscriptionsPayload extends FetchPayload {
  feature: PremiumFeature;
  placeUuid: string;
}
export const fetchSubscriptions = createAction<FetchSubscriptionsPayload>('FETCH_SUBSCRIPTIONS');

export interface SubscriptionsFetchedPayload extends TimestampPayload {
  subscriptions: Subscription[];
  feature: PremiumFeature;
  placeUuid: string;
}
export const subscriptionsFetched = createAction<SubscriptionsFetchedPayload>('SUBSCRIPTIONS_FETCHED');

export interface SubscriptionsFetchFailedPayload extends TimestampPayload {
  feature: PremiumFeature;
  placeUuid: string;
}
export const subscriptionsFetchFailed = createAction<SubscriptionsFetchFailedPayload>('SUBSCRIPTIONS_FETCH_FAILED');
